import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import Tabs from '@material-ui/core/Tabs';
import moment from 'moment';
import 'moment/locale/ru';
import Radio from '@material-ui/core/Radio';
import {
  FormControl, FormControlLabel, FormGroup, FormLabel, Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  RadioGroup,
  Tab,
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  createPlayground,
  updatePlayground,
  uploadPhoto,
  deletePhoto,
  setCover,
  deletePlayground,
} from './../../ducks/playgrounds';
import { fetchCenters } from './../../ducks/centers';
import Timetable from '../../components/Timetable';
import ConfirmDialog from '../../components/ConfirmDialog';
import AdminPageShell from '../../components/admin/AdminPageShell';
import api, { API_URL } from '../../lib/api';
import { sportsEnum, workingHoursTypeEnum } from '../../enums';
import { sportFlagsToKeysArray as sportFlagsToKeysArrayUtil, sportKeysToFlagsArray } from '../../lib/sportUtils';

moment.locale('ru');

/** URL файла изображения (тот же хост API, что и fetch — не admin origin `/api`). */
const imageSrc = (imageId) => `${API_URL}/image/${imageId}`;

// API возвращает type слотов как число (0, 1, 2); фронт использует 'full'|'half'|'third'. После сохранения
// без нормализации find() не находит слоты и поля цен отображаются пустыми/нередактируемыми.
function normalizeWorkingHoursType(t) {
  if (t === 'full' || t === '0' || t === 0 || t === 'Full') return 'full';
  if (t === 'half' || t === '1' || t === 1 || t === 'Half') return 'half';
  if (t === 'third' || t === '2' || t === 2 || t === 'Third') return 'third';
  return 'full';
}

function normalizeWorkingHoursFromApi(workingHours) {
  if (!workingHours || typeof workingHours !== 'object') return workingHours;
  return {
    weekdays: (workingHours.weekdays || []).map(h => ({
      ...h,
      type: normalizeWorkingHoursType(h.type),
    })),
    weekend: (workingHours.weekend || []).map(h => ({
      ...h,
      type: normalizeWorkingHoursType(h.type),
    })),
  };
}

export class Playground extends Component {
  static propTypes = {
    // params: PropTypes.object.isRequired,
    deletePhoto: PropTypes.func.isRequired,
    updatePlayground: PropTypes.func.isRequired,
    userRole: PropTypes.string,
    createPlayground: PropTypes.func.isRequired,
    setCover: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    classes: PropTypes.object,
    sports: PropTypes.object,
    covers: PropTypes.object,
    centers: PropTypes.array,
    playgrounds: PropTypes.array,
    match: PropTypes.any.isRequired,
    deletePlayground: PropTypes.func.isRequired,
    fetchCenters: PropTypes.func.isRequired,
  };

  static defaultProps = {
    classes: {},
    sports: {},
    covers: {},
    centers: [],
    playgrounds: [],
  };
  constructor(props) {
    super(props);
    const { playgrounds, match } = this.props;
    const { id } = match.params;
    let playgroundModel;

    if (id) {
      playgroundModel = playgrounds.find(i => i.id === id - 0);
    }
    
    // Состояние для drag-and-drop цен (перетаскивание включается только при движении мыши, не при простом клике)
    this.dragState = {
      isDragging: false,
      draggedPrice: null,
      dragSource: null,
      pendingDrag: false,
      startX: 0,
      startY: 0,
    };
    
    this.handlePriceMouseUp = this.handlePriceMouseUp.bind(this);
    this.handlePriceMouseLeave = this.handlePriceMouseLeave.bind(this);
    this.handlePriceMouseMove = this.handlePriceMouseMove.bind(this);

    // Преобразуем workingHoursSports из Redux, если они есть
    // НО: приоритет отдаем данным из API в componentDidMount, так как они всегда актуальные
    let workingHoursSportsFromModel = {};
    if (id && playgroundModel && playgroundModel.workingHoursSports) {
      const sports = playgroundModel.workingHoursSports;
      console.log('🔍 Загрузка из Redux - workingHoursSports:', sports);
      Object.keys(sports).forEach(key => {
        // key может быть:
        // - числом: 0, 1, 2 (значения enum)
        // - строкой-числом: "0", "1", "2"
        // - строкой enum: "Full", "Half", "Third" (если используется StringEnumConverter)
        // - строкой lowercase: "full", "half", "third"
        let typeKey = key;
        const keyStr = String(key);
        const keyLower = keyStr.toLowerCase();
        
        if (key === 0 || keyStr === '0' || keyLower === 'full') typeKey = 'full';
        else if (key === 1 || keyStr === '1' || keyLower === 'half') typeKey = 'half';
        else if (key === 2 || keyStr === '2' || keyLower === 'third') typeKey = 'third';
        
        // Преобразуем числовые флаги в строковые ключи, если нужно
        const sportFlags = sports[key];
        if (sportFlags && Array.isArray(sportFlags)) {
          // Проверяем, являются ли значения числовыми кодами или строковыми ключами
          if (sportFlags.length > 0 && typeof sportFlags[0] === 'number') {
            workingHoursSportsFromModel[typeKey] = sportFlagsToKeysArrayUtil(sportFlags);
          } else {
            workingHoursSportsFromModel[typeKey] = sportFlags;
          }
        }
      });
      console.log('🔍 Преобразованные workingHoursSportsFromModel:', workingHoursSportsFromModel);
    }
    
    // При лёгкой загрузке списка в store нет images, workingHours и др. — задаём по умолчанию, полные данные подгрузятся в componentDidMount
    const safeDefaultsFromModel = playgroundModel
      ? {
          images: playgroundModel.images ?? [],
          workingHours: normalizeWorkingHoursFromApi(playgroundModel.workingHours) || { weekdays: [], weekend: [] },
          workingHoursTypes: playgroundModel.workingHoursTypes ?? ['full'],
        }
      : {};
    this.state = Object.assign(
      {},
      id
        ? {
          ...playgroundModel,
          ...safeDefaultsFromModel,
          division: [1, 2, 4],
          sport: playgroundModel ? sportFlagsToKeysArrayUtil(playgroundModel.sport) : ['football'],
          workingHoursSports: Object.keys(workingHoursSportsFromModel).length > 0 
            ? workingHoursSportsFromModel 
            : (playgroundModel.workingHoursSports || {}),
        }
        : {
          id,
          name: '',
          sport: ['football'],
          complexId: null,
          cover: null,
          type: 'Indoor',
          weedkays: '',
          weekend: '',
          tribune: 0,
          tracksNumber: 0,
          images: [],
          lighting: false,
          workingHours: { weekdays: [], weekend: [] },
          workingHoursTypes: ['full'],
          workingHoursSports: {},
        },
      {
        saveEnable: false,
        isSaving: false,
        saveError: null,
        currentMenu: 0, // 0 - редактирование площадки, 1 - Расписание, 2 - Отзывыв
        reviews: [],
        choosenReview: null, // при выборе Отзыва появляется модальное окно
        currentWorkingHoursTypes: workingHoursTypeEnum.full,
      }
    );
  }
  
  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handlePriceMouseUp);
    document.removeEventListener('mousemove', this.handlePriceMouseMove);
    document.removeEventListener('mouseleave', this.handlePriceMouseLeave);
  }

  async componentDidMount() {
    this.getComments(this.state.id);
    
    // Если в URL есть параметр date или sectionId, переключаемся на вкладку расписания
    const initialDate = this.getInitialDateFromQuery();
    const initialSectionId = this.getInitialSectionIdFromQuery();
    if (initialDate || initialSectionId) {
      this.setState({ currentMenu: 1 }); // 1 = Расписание
    }
    
    // Загружаем актуальный список центров для выбора при создании площадки
    // Это особенно важно для модераторов, которые только что создали комплекс
    if (!this.state.id) {
      try {
        await this.props.fetchCenters();
      } catch (e) {
        console.error('Ошибка загрузки центров:', e);
      }
    } else {
      // Если редактируем существующую площадку, загружаем полные данные через API
      // Это нужно, чтобы получить изображения, которые могут отсутствовать в Redux state
      try {
        const fullPlaygroundData = await api.getPlayground(this.state.id);
        console.log('🔍 Загруженные данные площадки:', fullPlaygroundData);
        console.log('🔍 Sports из API:', fullPlaygroundData?.sports);
        
        if (fullPlaygroundData) {
          // Обновляем state с полными данными, включая изображения
          // Преобразуем sports из формата { "0": [32, 128], "1": [32] } или { "Full": [32, 128], "Half": [32] } 
          // в формат { "full": ['football', 'tennis'], "half": ['football'] }
          const sports = fullPlaygroundData.sports || {};
          console.log('🔍 Sports объект:', sports);
          console.log('🔍 Sports keys:', Object.keys(sports));
          
          const workingHoursSports = {};
          Object.keys(sports).forEach(key => {
            // key может быть:
            // - числом: 0, 1, 2 (значения enum)
            // - строкой-числом: "0", "1", "2"
            // - строкой enum: "Full", "Half", "Third" (если используется StringEnumConverter)
            // - строкой lowercase: "full", "half", "third"
            let typeKey = key;
            const keyStr = String(key);
            const keyLower = keyStr.toLowerCase();
            
            console.log(`🔍 Обработка ключа: ${key} (тип: ${typeof key}, строка: "${keyStr}", lowercase: "${keyLower}")`);
            
            // Обрабатываем все возможные форматы ключей
            if (key === 0 || keyStr === '0' || keyLower === 'full' || keyLower === 'full') typeKey = 'full';
            else if (key === 1 || keyStr === '1' || keyLower === 'half' || keyLower === 'half') typeKey = 'half';
            else if (key === 2 || keyStr === '2' || keyLower === 'third' || keyLower === 'third') typeKey = 'third';
            else {
              // Если ключ не распознан, пытаемся преобразовать
              console.warn(`⚠️ Неизвестный ключ: ${key}, используем как есть`);
            }
            
            // Преобразуем числовые флаги в строковые ключи
            const sportFlags = sports[key];
            console.log(`🔍 Sport flags для ${key}:`, sportFlags);
            
            if (sportFlags && Array.isArray(sportFlags) && sportFlags.length > 0) {
              const sportKeys = sportFlagsToKeysArrayUtil(sportFlags);
              console.log(`🔍 Преобразованные ключи для ${typeKey}:`, sportKeys);
              workingHoursSports[typeKey] = sportKeys;
            }
          });
          
          console.log('🔍 Итоговый workingHoursSports:', workingHoursSports);
          
          // Если workingHoursSports пустой, но есть sport и workingHoursTypes, создаем workingHoursSports
          // для всех типов расписаний из общих видов спорта
          let finalWorkingHoursSports = workingHoursSports;
          if (Object.keys(workingHoursSports).length === 0 && fullPlaygroundData.sport && fullPlaygroundData.sport.length > 0) {
            const sportKeys = sportFlagsToKeysArrayUtil(fullPlaygroundData.sport);
            const workingHoursTypes = fullPlaygroundData.workingHoursTypes || ['full'];
            finalWorkingHoursSports = {};
            workingHoursTypes.forEach(type => {
              finalWorkingHoursSports[type] = [...sportKeys];
            });
            console.log('🔍 Создан workingHoursSports из sport:', finalWorkingHoursSports);
          }
          
          this.setState({
            ...fullPlaygroundData,
            sport: fullPlaygroundData.sport ? sportFlagsToKeysArrayUtil(fullPlaygroundData.sport) : ['football'],
            images: fullPlaygroundData.images || [],
            workingHoursSports: finalWorkingHoursSports,
            workingHours: normalizeWorkingHoursFromApi(fullPlaygroundData.workingHours) || fullPlaygroundData.workingHours,
          });
        }
      } catch (e) {
        console.error('Ошибка загрузки данных площадки:', e);
      }
    }
  }

  // Потенциальное начало перетаскивания (реальное перетаскивание включается только при движении мыши > 5px)
  onPriceMouseDown = (e, dayType, interval, type, price) => {
    if (e.button !== 0 || !price || price === '') return;
    // Не вызываем preventDefault(), чтобы клик мог сфокусировать инпут и дать возможность редактировать цену
    this.dragState = {
      isDragging: false,
      draggedPrice: price,
      dragSource: { dayType, interval, type },
      pendingDrag: true,
      startX: e.clientX,
      startY: e.clientY,
    };
    document.addEventListener('mouseup', this.handlePriceMouseUp);
    document.addEventListener('mousemove', this.handlePriceMouseMove);
    document.addEventListener('mouseleave', this.handlePriceMouseLeave);
  }

  handlePriceMouseMove = (e) => {
    const d = this.dragState;
    if (!d.pendingDrag || d.isDragging) return;
    const dx = Math.abs(e.clientX - d.startX);
    const dy = Math.abs(e.clientY - d.startY);
    if (dx > 5 || dy > 5) {
      d.isDragging = true;
      d.pendingDrag = false;
      document.removeEventListener('mousemove', this.handlePriceMouseMove);
    }
  }

  // Применение перетащенной цены к целевой ячейке
  applyDraggedPrice = (dayType, interval, type) => {
    const { dragState } = this;
    if (!dragState.isDragging || !dragState.draggedPrice) return;
    
    // Применяем только если та же категория дня (weekdays/weekend) и тот же тип расписания
    if (dragState.dragSource.dayType === dayType && normalizeWorkingHoursType(dragState.dragSource.type) === normalizeWorkingHoursType(type)) {
      // Создаем синтетическое событие для использования существующей логики
      const syntheticEvent = {
        target: {
          value: dragState.draggedPrice,
        },
      };
      this.onChangeWorkingHoursPrice(syntheticEvent, dayType, interval, type);
    }
  }

  handlePriceMouseUp = () => {
    const wasDragging = this.dragState.isDragging;
    this.dragState.isDragging = false;
    this.dragState.draggedPrice = null;
    this.dragState.dragSource = null;
    this.dragState.pendingDrag = false;
    document.removeEventListener('mouseup', this.handlePriceMouseUp);
    document.removeEventListener('mousemove', this.handlePriceMouseMove);
    document.removeEventListener('mouseleave', this.handlePriceMouseLeave);
    if (wasDragging) this.forceUpdate();
  }

  handlePriceMouseLeave = () => {
    if (this.dragState.isDragging || this.dragState.pendingDrag) {
      this.handlePriceMouseUp();
    }
  }

  // Проверка, является ли ячейка источником перетаскивания
  isDragSource = (dayType, interval, type) => {
    const { dragState } = this;
    return dragState.isDragging &&
           dragState.dragSource &&
           dragState.dragSource.dayType === dayType &&
           dragState.dragSource.interval === interval &&
           dragState.dragSource.type === type;
  }

  // Проверка, можно ли применить перетащенную цену к этой ячейке
  canApplyDrag = (dayType, interval, type) => {
    const { dragState } = this;
    return dragState.isDragging &&
           dragState.dragSource &&
           dragState.dragSource.dayType === dayType &&
           dragState.dragSource.type === type &&
           (dragState.dragSource.interval !== interval); // Не применяем к источнику
  }

  // handler смены стоимости часа в Режиме работы
  onChangeWorkingHoursPrice(event, dayType, interval, type) {
    const { workingHours } = this.state;
    const intervalNum = Number(interval);
    const source = workingHours && workingHours[dayType] ? workingHours[dayType] : [];
    const typeNorm = normalizeWorkingHoursType(type);
    // Копируем массив и удаляем все записи для этого интервала и типа (interval может быть number/string с API)
    const newDay = source.filter((h) => {
      if (Number(h.interval) !== intervalNum) return true;
      return normalizeWorkingHoursType(h.type) !== typeNorm;
    });
    const rawValue = event.target.value;
    if (rawValue !== '' && rawValue !== undefined) {
      const price = rawValue === '' ? 0 : parseInt(rawValue, 10);
      if (!Number.isNaN(price)) {
        newDay.push({
          interval: intervalNum,
          price,
          type: typeNorm,
        });
      }
    }
    this.setState({
      workingHours: {
        ...workingHours,
        [dayType]: newDay,
      },
      saveEnable: this.validate(),
    });
  }


  // логика фотографий
  onDrop = async (files) => {
    if (!files || files.length === 0 || !this.state.id) return;

    const uploaded = [];
    for (const file of files) {
      try {
        const action = await this.props.uploadPhoto(file, this.state.id);
        if (action && action.payload && action.payload.image) {
          uploaded.push(action.payload.image);
        }
      } catch (e) {
        console.error('Ошибка загрузки фотографии:', e);
      }
    }

    if (uploaded.length > 0) {
      this.setState(prev => ({
        images: [...(prev.images || []), ...uploaded],
      }));
    }
  };

  // получение Отзывов api
  getComments = async () => {
    if (this.state.id) {
      const reviews = await api.getComments(this.state.id);

      if (reviews) {
        this.setState({ reviews });
      }
    }
  };

  setCover = async (id) => {
    await this.props.setCover(this.state.id, this.state.images, id);
    this.setState(prev => ({
      images: (prev.images || []).map(i =>
        (i.id === id ? { ...i, isMain: true } : { ...i, isMain: false })),
    }));
  };

  addWorkingHoursType = () => {
    const newType = this.state.workingHoursTypes.includes(workingHoursTypeEnum.half) ?
      workingHoursTypeEnum.third
      : workingHoursTypeEnum.half;
    
    // При добавлении нового типа расписания, инициализируем для него пустой список видов спорта
    // Пользователь сможет выбрать виды спорта для этого типа во вкладке "Расписание"
    const workingHoursSports = { ...this.state.workingHoursSports };
    if (!workingHoursSports[newType]) {
      workingHoursSports[newType] = [];
    }
    
    // ВАЖНО: НЕ копируем расписание из существующего типа - новое расписание должно быть пустым
    // Пользователь должен сам настроить часы работы и цены для нового типа
    // Расписание (workingHours) уже содержит type для каждого интервала, поэтому новые интервалы
    // будут создаваться при вводе цен в режиме работы
    
    // Автоматически переключаемся на новый тип расписания после добавления
    this.setState({
      workingHoursTypes: [...this.state.workingHoursTypes, newType],
      workingHoursSports,
      currentWorkingHoursTypes: newType, // Переключаемся на новый тип
    });
  };

  changeCurrentWorkingHoursType = (type) => {
    this.setState({ currentWorkingHoursTypes: type });
  }

  handleWorkingHoursSportsChange = (type, sports) => {
    console.log(`🟢 handleWorkingHoursSportsChange вызван: type=${type}, sports=`, sports);
    console.log(`🟢 Текущий workingHoursSports:`, this.state.workingHoursSports);
    
    // Нормализуем тип для сравнения (приводим к стандартному формату: 'full', 'half', 'third')
    const normalizeType = (t) => {
      if (t === 'full' || t === '0' || t === 0 || t === 'Full') return 'full';
      if (t === 'half' || t === '1' || t === 1 || t === 'Half') return 'half';
      if (t === 'third' || t === '2' || t === 2 || t === 'Third') return 'third';
      return t; // Если не распознан, возвращаем как есть
    };
    
    const normalizedType = normalizeType(type);
    console.log(`🟢 Нормализованный type: ${normalizedType} (исходный: ${type})`);
    
    // Создаем новый объект и новые массивы для всех типов, чтобы React увидел изменение
    // Это гарантирует, что изменение одного типа не повлияет на другие
    const currentWorkingHoursSports = this.state.workingHoursSports || {};
    const workingHoursSports = {};
    
    // КРИТИЧНО: Сначала находим существующий ключ для этого типа (может быть в разных форматах)
    // Это нужно, чтобы не создавать дубликаты и правильно обновлять существующий ключ
    let existingKey = null;
    Object.keys(currentWorkingHoursSports).forEach(key => {
      const normalizedKey = normalizeType(key);
      if (normalizedKey === normalizedType) {
        existingKey = key; // Находим существующий ключ (может быть 'third', '2', 'Third' и т.д.)
      }
    });
    
    console.log(`🟢 Найден существующий ключ для типа ${normalizedType}:`, existingKey);
    
    // Копируем все существующие типы с новыми массивами
    Object.keys(currentWorkingHoursSports).forEach(key => {
      // Нормализуем ключ для сравнения
      const normalizedKey = normalizeType(key);
      console.log(`🟢 Сравнение: normalizedKey=${normalizedKey}, normalizedType=${normalizedType}, key=${key}, type=${type}`);
      
      // ВАЖНО: Сравниваем не только нормализованные значения, но и исходные ключи
      // Это предотвращает обновление неправильного ключа, если есть дубликаты (например, '2' и 'third')
      if (key === existingKey || (normalizedKey === normalizedType && !existingKey)) {
        // Для изменяемого типа создаем новый массив из переданных данных
        // Используем исходный ключ (key), чтобы сохранить формат
        workingHoursSports[key] = Array.isArray(sports) ? [...sports] : [];
        console.log(`🟢 Обновляем тип ${key} (нормализованный: ${normalizedKey}) с новыми данными:`, sports);
      } else {
        // Для остальных типов создаем новый массив из существующих данных
        workingHoursSports[key] = Array.isArray(currentWorkingHoursSports[key]) 
          ? [...currentWorkingHoursSports[key]] 
          : [];
        console.log(`🟢 Сохраняем тип ${key} (нормализованный: ${normalizedKey}) без изменений:`, workingHoursSports[key]);
      }
    });
    
    // Если типа еще не было в объекте, добавляем его с нормализованным ключом
    if (!existingKey) {
      workingHoursSports[normalizedType] = Array.isArray(sports) ? [...sports] : [];
      console.log(`🟢 Добавляем новый тип ${normalizedType} с данными:`, sports);
    }
    
    console.log(`🟢 Новый workingHoursSports:`, workingHoursSports);
    
    // При изменении видов спорта для расписания, активируем кнопку сохранения
    // если площадка уже создана (есть id)
    this.setState({ 
      workingHoursSports,
      // Активируем кнопку сохранения, если площадка уже создана
      saveEnable: this.state.id ? true : this.validate(),
    });
  }

  deletePhoto = async (id) => {
    await this.props.deletePhoto(this.state.id, id);
    this.setState(prev => ({
      images: (prev.images || []).filter(i => i.id !== id),
    }));
  };

  submit = async () => {
    if (this.validate()) {
      // Показываем индикатор загрузки
      this.setState({ isSaving: true, saveError: null });
      
      try {
      const sportFlags = sportKeysToFlagsArray(this.state.sport);
      
      // Преобразуем workingHoursSports из формата { "full": ['football', 'tennis'], "half": ['football'] }
      // в формат { 0: [32, 128], 1: [32] } для бэкенда (числовые ключи enum)
      // StringEnumConverter НЕ работает для ключей словаря Dictionary<WorkingHoursType, ...>
      // Поэтому используем числовые ключи (0, 1, 2), которые соответствуют значениям enum
      const workingHoursSports = this.state.workingHoursSports || {};
      console.log('📤 Текущий workingHoursSports перед отправкой:', workingHoursSports);
      console.log('📤 Object.keys(workingHoursSports):', Object.keys(workingHoursSports));
      console.log('📤 workingHoursSports[full]:', workingHoursSports['full']);
      console.log('📤 workingHoursSports[half]:', workingHoursSports['half']);
      console.log('📤 workingHoursSports[third]:', workingHoursSports['third']);
      console.log('📤 workingHoursTypes:', this.state.workingHoursTypes);
      
      const sportsForBackend = {};
      
      // ВАЖНО: Отправляем данные только для типов, которые есть в workingHoursSports
      // Это гарантирует, что мы не удалим данные для типов, которые не были изменены
      // Если тип есть в workingHoursSports (даже с пустым массивом), значит он был изменен, и мы отправляем его
      // Если типа нет в workingHoursSports, значит он не был изменен, и мы его не отправляем (бэкенд сохранит старые данные)
      Object.keys(workingHoursSports).forEach(key => {
        let typeValue;
        // Преобразуем в числовые ключи enum (0, 1, 2)
        if (key === 'full' || key === '0' || key === 0 || key === 'Full') typeValue = 0; // Full = 0
        else if (key === 'half' || key === '1' || key === 1 || key === 'Half') typeValue = 1; // Half = 1
        else if (key === 'third' || key === '2' || key === 2 || key === 'Third') typeValue = 2; // Third = 2
        else {
          // Пытаемся преобразовать строковый ключ в число
          const normalizedKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
          if (normalizedKey === 'Full') typeValue = 0;
          else if (normalizedKey === 'Half') typeValue = 1;
          else if (normalizedKey === 'Third') typeValue = 2;
          else {
            // Если это число, используем его
            const numKey = parseInt(key, 10);
            if (numKey === 0) typeValue = 0;
            else if (numKey === 1) typeValue = 1;
            else if (numKey === 2) typeValue = 2;
            else typeValue = 0; // По умолчанию Full (0)
          }
        }
        
        const sportsArray = workingHoursSports[key];
        console.log(`📤 Обработка ключа ${key} (typeValue=${typeValue}):`, sportsArray);
        console.log(`📤 sportsArray is array:`, Array.isArray(sportsArray));
        console.log(`📤 sportsArray length:`, sportsArray?.length);
        
        // ВАЖНО: Отправляем даже пустые массивы, чтобы бэкенд знал, что для этого типа нет видов спорта
        // Это нужно, чтобы бэкенд удалил старые записи PlaygroundSport для этого типа
        if (sportsArray && Array.isArray(sportsArray)) {
          if (sportsArray.length > 0) {
            // КРИТИЧНО: Проверяем, являются ли значения числовыми флагами или строковыми ключами
            // Если это числовые флаги, сначала преобразуем их в строковые ключи, а затем обратно в флаги
            // Это нужно, потому что в workingHoursSports могут попасть числовые флаги из ответа API
            let sportKeys = sportsArray;
            if (typeof sportsArray[0] === 'number') {
              // Это числовые флаги, преобразуем в строковые ключи
              console.log(`📤 Обнаружены числовые флаги для ${key}, преобразуем в строковые ключи:`, sportsArray);
              sportKeys = sportFlagsToKeysArrayUtil(sportsArray);
              console.log(`📤 Преобразованные ключи:`, sportKeys);
            }
            
            // Преобразуем строковые ключи видов спорта в числовые флаги
            const sportFlags = sportKeysToFlagsArray(sportKeys);
            console.log(`📤 Преобразованные флаги для ${key}:`, sportFlags);
            sportsForBackend[typeValue] = sportFlags;
          } else {
            // Отправляем пустой массив, чтобы бэкенд удалил старые записи для этого типа
            console.log(`📤 Отправляем пустой массив для ${key} (typeValue=${typeValue}), чтобы бэкенд удалил старые записи`);
            sportsForBackend[typeValue] = [];
          }
        } else {
          console.warn(`⚠️ Пропускаем ключ ${key}: не является массивом`);
        }
      });
      
      // ВАЖНО: Если workingHoursSports пустой, но есть sport, создаем sportsForBackend из sport для всех типов расписаний
      // Это предотвращает потерю данных при сохранении, особенно при создании новой площадки
      if (Object.keys(sportsForBackend).length === 0 && this.state.sport && this.state.sport.length > 0) {
        console.warn('⚠️ workingHoursSports пустой, но есть sport. Создаем sportsForBackend из sport для всех типов расписаний');
        const sportFlags = sportKeysToFlagsArray(this.state.sport);
        // ВАЖНО: Если workingHoursTypes пустой, используем ['full'] по умолчанию
        // Это гарантирует, что при создании новой площадки виды спорта будут сохранены
        const workingHoursTypes = (this.state.workingHoursTypes && this.state.workingHoursTypes.length > 0) 
          ? this.state.workingHoursTypes 
          : ['full'];
        console.log('📤 workingHoursTypes для создания sportsForBackend:', workingHoursTypes);
        workingHoursTypes.forEach(type => {
          if (type === 'full' || type === '0' || type === 0 || type === 'Full') {
            sportsForBackend[0] = sportFlags; // Full = 0
          } else if (type === 'half' || type === '1' || type === 1 || type === 'Half') {
            sportsForBackend[1] = sportFlags; // Half = 1
          } else if (type === 'third' || type === '2' || type === 2 || type === 'Third') {
            sportsForBackend[2] = sportFlags; // Third = 2
          }
        });
        console.log('📤 Создан sportsForBackend из sport:', sportsForBackend);
      }
      
      // Отправляем только нужные поля, чтобы избежать ошибок валидации
      // Если есть sports (словарь по типам расписаний), не отправляем sport (общий список)
      // чтобы бэкенд не создавал записи PlaygroundSport для видов спорта, которых нет в расписаниях
      const playgroundData = {
        id: this.state.id,
        name: this.state.name,
        complexId: this.state.complexId,
        price: this.state.price,
        // Отправляем sport только если sports пуст (для обратной совместимости)
        ...(Object.keys(sportsForBackend).length > 0 ? {} : { sport: sportFlags }),
        // Отправляем sports только если он не пуст, иначе не отправляем вообще (не undefined, не null)
        ...(Object.keys(sportsForBackend).length > 0 ? { sports: sportsForBackend } : {}), // Отправляем как "sports" (с маленькой буквы), бэкенд маппит это в "Sports"
        cover: this.state.cover,
        weekdays: this.state.workingHours?.weekdays || [],
        weekend: this.state.workingHours?.weekend || [],
        tribune: this.state.tribune,
        type: this.state.type,
        lighting: this.state.lighting,
        workingHours: this.state.workingHours,
        // ВАЖНО: Если workingHoursTypes пустой, но есть sport или workingHoursSports, используем ['full'] по умолчанию
        // Это гарантирует, что при создании новой площадки виды спорта будут сохранены
        workingHoursTypes: (this.state.workingHoursTypes && this.state.workingHoursTypes.length > 0) 
          ? this.state.workingHoursTypes 
          : ((this.state.sport && this.state.sport.length > 0) || (this.state.workingHoursSports && Object.keys(this.state.workingHoursSports).length > 0))
            ? ['full']
            : [],
        womensClub: this.state.womensClub,
        cafe: this.state.cafe,
        tracksNumber: this.state.tracksNumber,
        pool: this.state.pool,
        // ВАЖНО: передаем workingHoursSports для совместимости с ducks/playgrounds.js
        // но приоритет имеет sports (который уже преобразован в числовые ключи)
        workingHoursSports: Object.keys(sportsForBackend).length > 0 ? sportsForBackend : undefined,
      };
      
      console.log('📤 Данные для отправки на бэкенд:', JSON.stringify(playgroundData, null, 2));
      console.log('📤 sportsForBackend:', sportsForBackend);
      console.log('📤 Object.keys(sportsForBackend):', Object.keys(sportsForBackend));
      
      if (this.state.id) {
        try {
          const action = await this.props.updatePlayground(playgroundData);
          // updatePlayground возвращает Redux action {type, payload}
          const result = action?.payload || {};
        
        console.log('📥 Redux action после сохранения:', action);
        console.log('📥 Payload из action:', result);
        
        // После сохранения обновляем состояние из ответа API
        // Преобразуем sports из ответа в workingHoursSports для состояния
        let workingHoursSports = {};
        
        // Проверяем, что пришло в result
        console.log('📥 result.workingHoursSports:', result?.workingHoursSports);
        console.log('📥 result.sports:', result?.sports);
        console.log('📥 result keys:', result ? Object.keys(result) : 'result is null/undefined');
        
        // ВАЖНО: проверяем, что workingHoursSports не пустой объект
        if (result && result.workingHoursSports && Object.keys(result.workingHoursSports).length > 0) {
          // Если workingHoursSports уже в правильном формате (строковые ключи), используем его
          // Но нужно проверить формат ключей
          const keys = Object.keys(result.workingHoursSports);
          console.log('📥 Ключи result.workingHoursSports:', keys);
          if (keys.length > 0 && (keys[0] === 'full' || keys[0] === 'half' || keys[0] === 'third')) {
            // Уже в правильном формате (строковые ключи)
            workingHoursSports = result.workingHoursSports;
          } else {
            // Нужно преобразовать из числовых ключей (0, 1, 2) или строковых числовых ("0", "1", "2")
            Object.keys(result.workingHoursSports).forEach(key => {
              let typeKey = key;
              const keyStr = String(key);
              if (key === 0 || keyStr === '0') typeKey = 'full';
              else if (key === 1 || keyStr === '1') typeKey = 'half';
              else if (key === 2 || keyStr === '2') typeKey = 'third';
              
              const sportData = result.workingHoursSports[key];
              // Проверяем, это уже строковые ключи или числовые флаги
              if (Array.isArray(sportData)) {
                if (sportData.length > 0 && typeof sportData[0] === 'string') {
                  // Уже строковые ключи
                  workingHoursSports[typeKey] = sportData;
                } else {
                  // Числовые флаги, нужно преобразовать
                  workingHoursSports[typeKey] = sportFlagsToKeysArrayUtil(sportData);
                }
              }
            });
          }
        } else if (result && result.sports) {
          // Если пришли sports в формате { 0: [...], 1: [...] } или { "Full": [...], "Half": [...] }, преобразуем в workingHoursSports
          Object.keys(result.sports).forEach(key => {
            // key может быть числом (0, 1, 2), строкой-числом ("0", "1", "2"), или строкой enum ("Full", "Half", "Third")
            let typeKey = key;
            const keyStr = String(key);
            const keyLower = keyStr.toLowerCase();
            
            // Преобразуем в стандартный формат ('full', 'half', 'third')
            if (key === 0 || keyStr === '0' || keyLower === 'full') typeKey = 'full';
            else if (key === 1 || keyStr === '1' || keyLower === 'half') typeKey = 'half';
            else if (key === 2 || keyStr === '2' || keyLower === 'third') typeKey = 'third';
            
            const sportFlags = result.sports[key];
            // ВАЖНО: Добавляем тип даже если массив пустой, чтобы сохранить информацию о том, что для этого типа нет видов спорта
            if (Array.isArray(sportFlags)) {
              // Преобразуем числовые флаги в строковые ключи (даже если массив пустой)
              workingHoursSports[typeKey] = sportFlags.length > 0 
                ? sportFlagsToKeysArrayUtil(sportFlags) 
                : [];
            }
          });
        }
        
        // Обновляем состояние из ответа API
        // НЕ перезаписываем все состояние, только нужные поля, чтобы не потерять локальные изменения
        // Важно: сохраняем workingHoursSports из текущего состояния, если они есть, так как они могут быть изменены пользователем
        // КРИТИЧНО: если workingHoursSports из API пустой, НЕ перезаписываем текущее состояние!
        // ВАЖНО: Объединяем данные из API с текущими данными, чтобы не потерять типы расписаний, которых нет в ответе API
        let finalWorkingHoursSports = { ...this.state.workingHoursSports } || {};
        
        if (Object.keys(workingHoursSports).length > 0) {
          // Если из API пришли данные, обновляем только те типы, которые есть в ответе
          // Это гарантирует, что если в ответе нет какого-то типа (например, 'third'), мы не потеряем его данные
          // ВАЖНО: Сохраняем все существующие типы из текущего состояния, обновляя только те, которые пришли из API
          Object.keys(workingHoursSports).forEach(type => {
            const sportData = workingHoursSports[type];
            // КРИТИЧНО: Проверяем, являются ли значения числовыми флагами или строковыми ключами
            // Если это числовые флаги, преобразуем их в строковые ключи
            if (Array.isArray(sportData) && sportData.length > 0 && typeof sportData[0] === 'number') {
              // Это числовые флаги, преобразуем в строковые ключи
              const sportKeys = sportFlagsToKeysArrayUtil(sportData);
              finalWorkingHoursSports[type] = sportKeys;
              console.log(`📥 Обновляем тип ${type} из API: числовые флаги ${JSON.stringify(sportData)} -> строковые ключи ${JSON.stringify(sportKeys)}`);
            } else {
              // Уже строковые ключи или пустой массив
              finalWorkingHoursSports[type] = sportData;
              console.log(`📥 Обновляем тип ${type} из API:`, sportData);
            }
          });
          // ВАЖНО: Сохраняем типы, которых нет в ответе API, но есть в текущем состоянии
          // Это нужно, потому что бэкенд не возвращает типы с пустыми массивами
          // Например, если пользователь удалил все виды спорта из "1/3", бэкенд не вернет ключ '2' в Sports
          Object.keys(this.state.workingHoursSports || {}).forEach(type => {
            // Нормализуем тип для сравнения
            const normalizeType = (t) => {
              if (t === 'full' || t === '0' || t === 0 || t === 'Full') return 'full';
              if (t === 'half' || t === '1' || t === 1 || t === 'Half') return 'half';
              if (t === 'third' || t === '2' || t === 2 || t === 'Third') return 'third';
              return t;
            };
            const normalizedType = normalizeType(type);
            
            // Проверяем, есть ли этот нормализованный тип в ответе API
            const existsInApi = Object.keys(workingHoursSports).some(apiType => normalizeType(apiType) === normalizedType);
            
            if (!existsInApi) {
              console.log(`📥 Сохраняем тип ${type} (нормализованный: ${normalizedType}) из текущего состояния (не было в ответе API):`, this.state.workingHoursSports[type]);
              // Тип уже есть в finalWorkingHoursSports, так как мы скопировали его в начале (строка 597)
              // Но убеждаемся, что он там есть
              if (!finalWorkingHoursSports.hasOwnProperty(type)) {
                finalWorkingHoursSports[type] = this.state.workingHoursSports[type];
              }
            }
          });
          console.log('📥 Объединенные workingHoursSports:', finalWorkingHoursSports);
          console.log('📥 Ключи в объединенных workingHoursSports:', Object.keys(finalWorkingHoursSports));
        } else if (result && result.sports && Object.keys(result.sports).length === 0) {
          // Если API вернул пустой sports, это может означать, что данные не сохранились
          // В этом случае НЕ обновляем workingHoursSports, оставляем текущие
          console.warn('⚠️ API вернул пустой sports, сохраняем текущие workingHoursSports');
          // finalWorkingHoursSports уже содержит текущие данные
        }
        // Если workingHoursSports из API пустой, но текущие есть, сохраняем текущие
        
        // ВАЖНО: НЕ используем ...result напрямую, так как это может перезаписать важные поля
        // Вместо этого явно указываем, какие поля обновлять
        const updatedState = {
          ...this.state, // Сохраняем текущее состояние
          // Обновляем только нужные поля из result, исключая workingHoursSports и sports
          id: result.id ?? this.state.id,
          name: result.name ?? this.state.name,
          complexId: result.complexId ?? this.state.complexId,
          price: result.price ?? this.state.price,
          cover: result.cover ?? this.state.cover,
          tribune: result.tribune ?? this.state.tribune,
          type: result.type ?? this.state.type,
          lighting: result.lighting ?? this.state.lighting,
          // Не перезаписываем workingHours из ответа API: после сохранения ответ может вернуть другую структуру (type как 0 вместо 'full'),
          // из-за чего find/onChange перестают находить слот и поля цен кажутся нередактируемыми. Оставляем текущие данные в state.
          workingHours: this.state.workingHours,
          workingHoursTypes: result.workingHoursTypes ?? this.state.workingHoursTypes,
          womensClub: result.womensClub ?? this.state.womensClub,
          cafe: result.cafe ?? this.state.cafe,
          tracksNumber: result.tracksNumber ?? this.state.tracksNumber,
          pool: result.pool ?? this.state.pool,
          rate: result.rate ?? this.state.rate,
          images: result.images ?? this.state.images,
          // КРИТИЧНО: НЕ обновляем sport из ответа API, так как бэкенд вычисляет его из всех Sports
          // Это может привести к потере данных, если пользователь удалил вид спорта из одного типа расписания
          // Вместо этого сохраняем текущее значение sport, чтобы не потерять пользовательские изменения
          sport: this.state.sport, // Сохраняем текущее значение, не обновляем из API
          workingHoursSports: finalWorkingHoursSports, // Используем обработанные данные
        };
        
        console.log('📥 workingHoursSports из API:', workingHoursSports);
        console.log('📥 Текущий workingHoursSports в state:', this.state.workingHoursSports);
        console.log('📥 Финальный workingHoursSports:', finalWorkingHoursSports);
        console.log('📥 Обновленное состояние:', updatedState);
        console.log('📥 result.sport:', result.sport);
        console.log('📥 Преобразованный sport:', (result.sport && Array.isArray(result.sport) && result.sport.length > 0) 
          ? sportFlagsToKeysArrayUtil(result.sport) 
          : this.state.sport);
        
        // Обновляем состояние и затем обновляем saveEnable
        this.setState(updatedState, () => {
          // После обновления состояния проверяем, нужно ли обновить saveEnable
          // saveEnable должен быть false, если данные не изменились (сохранены)
          // Но validate() всегда возвращает true, если поля заполнены, поэтому нужно проверить, были ли изменения
          // Пока оставляем validate(), но в будущем можно добавить сравнение с исходным состоянием
          const newSaveEnable = this.validate();
          console.log('📥 Обновление saveEnable после сохранения:', newSaveEnable);
          // ВАЖНО: после успешного сохранения устанавливаем saveEnable в false, чтобы кнопка стала неактивной
          // Это предотвратит повторное сохранение без изменений
          this.setState({ saveEnable: false, isSaving: false });
        });
        } catch (error) {
          console.error('❌ Ошибка при сохранении площадки:', error);
          this.setState({ 
            isSaving: false, 
            saveError: error.message || 'Ошибка при сохранении. Попробуйте еще раз.' 
          });
          alert(`Ошибка при сохранении: ${error.message || 'Неизвестная ошибка'}`);
          return;
        }
      } else {
        try {
          await this.props.createPlayground(playgroundData);
          this.props.history.push('/playgrounds');
        } catch (error) {
          console.error('❌ Ошибка при создании площадки:', error);
          this.setState({ 
            isSaving: false, 
            saveError: error.message || 'Ошибка при создании. Попробуйте еще раз.' 
          });
          alert(`Ошибка при создании: ${error.message || 'Неизвестная ошибка'}`);
          return;
        }
      }
      } catch (error) {
        console.error('❌ Общая ошибка при сохранении:', error);
        this.setState({ 
          isSaving: false, 
          saveError: error.message || 'Ошибка при сохранении. Попробуйте еще раз.' 
        });
        alert(`Ошибка при сохранении: ${error.message || 'Неизвестная ошибка'}`);
      }
    } else {
      alert('Заполните необходимые поля');
    }
  };

  deletePlayground = async () => {
    const { id } = this.state;
    if (id) {
      await this.props.deletePlayground(id);
      this.closeConfirm();
      this.props.history.push('/playgrounds');
    }
  };

  handleSelect = (value, name) => {
    console.log(`🔵 handleSelect вызван: name=${name}, value=`, value);
    
    if (name === 'sport') {
      // При изменении общего списка видов спорта, нужно синхронизировать workingHoursSports
      // Удаляем виды спорта, которых больше нет в общем списке, из всех типов расписаний
      const oldSport = this.state.sport || [];
      const newSport = value || [];
      const removedSports = oldSport.filter(s => !newSport.includes(s));
      const addedSports = newSport.filter(s => !oldSport.includes(s));
      
      console.log(`🔵 Старый список спорта:`, oldSport);
      console.log(`🔵 Новый список спорта:`, newSport);
      console.log(`🔵 Удаленные виды спорта:`, removedSports);
      console.log(`🔵 Добавленные виды спорта:`, addedSports);
      
      // Обновляем workingHoursSports только если были удаления или добавления
      if (removedSports.length > 0 || addedSports.length > 0) {
        const workingHoursSports = { ...this.state.workingHoursSports };
        
        // Удаляем удаленные виды спорта из всех типов расписаний
        if (removedSports.length > 0) {
          Object.keys(workingHoursSports).forEach(type => {
            if (workingHoursSports[type]) {
              workingHoursSports[type] = workingHoursSports[type].filter(s => !removedSports.includes(s));
              // Если массив стал пустым, можно оставить его или удалить ключ
              if (workingHoursSports[type].length === 0) {
                delete workingHoursSports[type];
              }
            }
          });
        }
        
        // Добавляем новые виды спорта во все существующие типы расписаний
        // Это нужно, чтобы при сохранении отправлялся sports, а не только sport
        if (addedSports.length > 0) {
          // Получаем все типы расписаний из workingHoursTypes
          // ВАЖНО: Если workingHoursTypes пустой, используем ['full'] по умолчанию
          // Это гарантирует, что при создании новой площадки виды спорта будут сохранены
          const allTypes = this.state.workingHoursTypes && this.state.workingHoursTypes.length > 0 
            ? this.state.workingHoursTypes 
            : ['full'];
          allTypes.forEach(type => {
            if (!workingHoursSports[type]) {
              workingHoursSports[type] = [];
            }
            // Добавляем новые виды спорта, если их еще нет
            addedSports.forEach(newSport => {
              if (!workingHoursSports[type].includes(newSport)) {
                workingHoursSports[type].push(newSport);
              }
            });
          });
        }
        
        // ВАЖНО: Если workingHoursSports пустой после всех изменений, но есть sport,
        // инициализируем workingHoursSports для типа 'full' со всеми видами спорта из sport
        // Это гарантирует, что при создании новой площадки виды спорта будут сохранены
        if (Object.keys(workingHoursSports).length === 0 && newSport && newSport.length > 0) {
          console.log('🔵 workingHoursSports пустой, но есть sport. Инициализируем workingHoursSports для типа "full"');
          workingHoursSports['full'] = [...newSport];
        }
        
        console.log(`🔵 Обновленный workingHoursSports:`, workingHoursSports);
        
        this.setState({ 
          [name]: value,
          workingHoursSports,
        }, () => {
          this.setState({ saveEnable: this.validate() });
        });
      } else {
        // Если список не изменился, просто обновляем sport
        this.setState({ [name]: value }, () => {
          this.setState({ saveEnable: this.validate() });
        });
      }
    } else {
      this.setState({ [name]: value }, () => {
        this.setState({ saveEnable: this.validate() });
      });
    }
  };

  handleChange = (event, checked) => {
    if (event.target.type === 'checkbox') {
      this.setState({
        [event.target.name]: checked,
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }

    this.setState({ saveEnable: this.validate() });
  };

  // удаление Отзывов api
  deleteComment = async (review) => {
    if (this.state.id) {
      const result = await api.deleteComment(review.id);
      if (result) {
        this.getComments(this.state.id);
        this.setState({ choosenReview: null });
      }
    }
  };

  getInitialDateFromQuery() {
    const { location } = this.props;
    if (location && location.search) {
      const params = new URLSearchParams(location.search);
      const date = params.get('date');
      if (date) {
        // Проверяем, что дата в правильном формате (YYYY-MM-DD)
        const dateMoment = moment(date, 'YYYY-MM-DD', true);
        if (dateMoment.isValid()) {
          return dateMoment.format('YYYY-MM-DD');
        }
      }
    }
    return null;
  }

  getInitialSectionIdFromQuery() {
    const { location } = this.props;
    if (location && location.search) {
      const params = new URLSearchParams(location.search);
      const sectionId = params.get('sectionId');
      if (sectionId && /^\d+$/.test(sectionId)) {
        return sectionId;
      }
    }
    return '';
  }

  validate() {
    const { name, sport, complexId } = this.state;
    return !!(name && complexId && sport);
  }

  openConfirm = () => {
    this.setState({
      openConfirm: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      openConfirm: false,
    });
  };

  // Режим работы
  renderWorkingHours = () => {
    const { classes } = this.props;
    const {
      currentWorkingHoursTypes,
      workingHours,
      sport,
      workingHoursSports,
    } = this.state;

    const currentTypeLabel = currentWorkingHoursTypes === 'full' ? 'целиком' : 
                            currentWorkingHoursTypes === 'half' ? '1/2' : '1/3';

    // Получаем доступные виды спорта для текущего типа расписания
    let availableSports = workingHoursSports[currentWorkingHoursTypes] || [];
    
    // Преобразуем числовые коды в строковые ключи, если нужно
    if (availableSports.length > 0 && typeof availableSports[0] === 'number') {
      availableSports = sportFlagsToKeysArrayUtil(availableSports);
    }
    
    // Преобразуем sport из числовых кодов в строковые ключи, если нужно
    let sportKeys = sport || [];
    if (sportKeys.length > 0 && typeof sportKeys[0] === 'number') {
      sportKeys = sportFlagsToKeysArrayUtil(sportKeys);
    }
    
    // Создаем опции для Select из общего списка видов спорта (sport)
    const sportOptions = sportKeys
      .filter(sportItem => {
        return sportItem && 
               typeof sportItem === 'string' && 
               sportsEnum[sportItem];
      })
      .map(sportItem => {
        const label = sportsEnum[sportItem];
        return {
          value: sportItem,
          label: label ? _.capitalize(label) : sportItem,
        };
      });
    
    // Текущие выбранные виды спорта для этого типа расписания
    const currentSportsValue = availableSports
      .filter(sportItem => {
        return sportItem && 
               typeof sportItem === 'string' && 
               sportsEnum[sportItem];
      })
      .map(sportItem => {
        const label = sportsEnum[sportItem];
        return {
          value: sportItem,
          label: label ? _.capitalize(label) : sportItem,
        };
      });

    return (
      <Paper className={classes.paperImages} elevation={2}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 25 }}>
          <div>
            <Typography type="h5" style={{ marginBottom: 8 }}>Режим работы</Typography>
            <Typography type="caption" className={classes.help} style={{ display: 'block', marginTop: 8 }}>
              Настройка расписания для формата "{currentTypeLabel}". Часы БЕЗ явного указания цены будут недоступны. Бесплатные часы - 0 рублей.
            </Typography>
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={this.submit}
            disabled={!this.state.saveEnable || this.state.isSaving}
            className={classes.button}
            style={{ marginLeft: 15 }}
          >
            Сохранить изменения
          </Button>
        </div>
        <div style={{ marginBottom: 25, padding: 20, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
          <Typography type="h6" style={{ marginBottom: 12 }}>Виды спорта для этого расписания:</Typography>
          <Typography type="caption" style={{ marginBottom: 12, color: '#666', display: 'block' }}>
            Выберите виды спорта, доступные для бронирования в формате "{currentTypeLabel}".
          </Typography>
          <Select
            multi
            value={currentSportsValue}
            onChange={(selected) => {
              const selectedSports = selected ? selected.map(item => item.value) : [];
              this.handleWorkingHoursSportsChange(currentWorkingHoursTypes, selectedSports);
            }}
            options={sportOptions}
            placeholder="Выберите виды спорта"
            noResultsText="Не найдено"
            clearable={false}
          />
        </div>
        <Table className={classes.workingHoursTable}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>Время</TableCell>
              <TableCell className={classes.tableHeader}>Будни</TableCell>
              <TableCell className={classes.tableHeader}>Выходные</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(48).keys()].map((interval) => {
              const intervalNum = Number(interval);
              const currentTypeNorm = normalizeWorkingHoursType(currentWorkingHoursTypes);
              const weekdayValue = (workingHours.weekdays || []).find(weekdayInterval =>
                Number(weekdayInterval.interval) === intervalNum &&
                normalizeWorkingHoursType(weekdayInterval.type) === currentTypeNorm);
              const weekendValue = (workingHours.weekend || []).find(weekendInterval =>
                Number(weekendInterval.interval) === intervalNum &&
                normalizeWorkingHoursType(weekendInterval.type) === currentTypeNorm);
              
              // Формируем интервал времени: от текущего до следующего
              const currentHour = Math.floor(interval / 2);
              const currentMinute = interval % 2 === 1 ? 30 : 0;
              const nextInterval = interval + 1;
              const nextHour = Math.floor(nextInterval / 2);
              const nextMinute = nextInterval % 2 === 1 ? 30 : 0;
              
              const timeFrom = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;
              const timeTo = `${String(nextHour).padStart(2, '0')}:${String(nextMinute).padStart(2, '0')}`;
              const timeLabel = `от ${timeFrom} до ${timeTo}`;
              
              return (
                <TableRow key={interval}>
                  <TableCell className={classes.timeCell}>
                    <Typography type="body2" style={{ fontWeight: 500 }}>
                      {timeLabel}
                  </Typography>
                  </TableCell>
                  <TableCell className={classes.priceCell}>
                  <Input
                      name={`weekdays-${interval}`}
                    type="number"
                    className={classes.price}
                      value={weekdayValue != null && weekdayValue.price !== undefined && weekdayValue.price !== null && weekdayValue.price !== '' ? String(weekdayValue.price) : ''}
                    onChange={event => this.onChangeWorkingHoursPrice(event, 'weekdays', interval, currentWorkingHoursTypes)}
                    onMouseDown={(e) => {
                        const price = weekdayValue ? weekdayValue.price : '';
                      if (price !== '') {
                        this.onPriceMouseDown(e, 'weekdays', interval, currentWorkingHoursTypes, price);
                      }
                    }}
                    onMouseEnter={() => {
                      if (this.canApplyDrag('weekdays', interval, currentWorkingHoursTypes)) {
                        this.applyDraggedPrice('weekdays', interval, currentWorkingHoursTypes);
                      }
                    }}
                    placeholder="Стоимость"
                    style={{
                        cursor: weekdayValue && weekdayValue.price ? 'grab' : 'text',
                      backgroundColor: this.isDragSource('weekdays', interval, currentWorkingHoursTypes) 
                        ? 'rgba(25, 118, 210, 0.2)' 
                        : this.canApplyDrag('weekdays', interval, currentWorkingHoursTypes)
                        ? 'rgba(76, 175, 80, 0.1)'
                        : 'transparent',
                      transition: 'background-color 0.2s',
                        width: '100%',
                    }}
                    onMouseUp={() => {
                      if (this.dragState.isDragging) {
                        this.handlePriceMouseUp();
                      }
                    }}
                  />
                  </TableCell>
                  <TableCell className={classes.priceCell}>
                  <Input
                      name={`weekend-${interval}`}
                    type="number"
                    className={classes.price}
                      value={weekendValue != null && weekendValue.price !== undefined && weekendValue.price !== null && weekendValue.price !== '' ? String(weekendValue.price) : ''}
                    onChange={event => this.onChangeWorkingHoursPrice(event, 'weekend', interval, currentWorkingHoursTypes)}
                    onMouseDown={(e) => {
                        const price = weekendValue ? weekendValue.price : '';
                      if (price !== '') {
                        this.onPriceMouseDown(e, 'weekend', interval, currentWorkingHoursTypes, price);
                      }
                    }}
                    onMouseEnter={() => {
                      if (this.canApplyDrag('weekend', interval, currentWorkingHoursTypes)) {
                        this.applyDraggedPrice('weekend', interval, currentWorkingHoursTypes);
                      }
                    }}
                    placeholder="Стоимость"
                    style={{
                        cursor: weekendValue && weekendValue.price ? 'grab' : 'text',
                      backgroundColor: this.isDragSource('weekend', interval, currentWorkingHoursTypes) 
                        ? 'rgba(25, 118, 210, 0.2)' 
                        : this.canApplyDrag('weekend', interval, currentWorkingHoursTypes)
                        ? 'rgba(76, 175, 80, 0.1)'
                        : 'transparent',
                      transition: 'background-color 0.2s',
                        width: '100%',
                    }}
                    onMouseUp={() => {
                      if (this.dragState.isDragging) {
                        this.handlePriceMouseUp();
                      }
                    }}
                  />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>);
  };

  render() {
    const { classes, sports } = this.props;
    const {
      openConfirm,
      sport,
      workingHoursTypes,
      currentWorkingHoursTypes,
      workingHoursSports,
    } = this.state;

    const sportsOptions = Object.entries(sportsEnum).map(([key, value]) => ({
      value: key,
      label: value,
    }));
    const coversOptions = _.flatMap(this.props.covers, (value, key) => ({
      value: key,
      label: _.capitalize(value),
    }));
    const centersOptions = _.map(this.props.centers, center => ({
      value: center.id,
      label: center.name,
    }));

    return (
      <AdminPageShell
        title={false}
        beforeHeader={
          <Button
            className={classes.backButton}
            onClick={() => {
              if (this.props.history) this.props.history.push('/playgrounds');
            }}
          >
            ← К списку площадок
          </Button>
        }
      >
      <div className={classes.pageBody}>
        <AppBar className={classes.paper} position="static" color="default">
          <Toolbar>
            <Tabs
              value={this.state.currentMenu}
              onChange={(event, value) => {
                this.setState({ currentMenu: value });
              }}
            >
              <Tab label={this.state.id ? 'Редактирование площадки' : 'Новая площадка'} />
              <Tab label="Расписание" />
              {this.state.id ? <Tab label="Отзывы" /> : null}
            </Tabs>
          </Toolbar>
        </AppBar>

        {this.state.currentMenu === 0 ? (
          <div>
            <Paper className={classes.paperImages} elevation={2}>
              <div className={classes.saveButtonContainer}>
                {this.state.id && (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.removeButton}
                    onClick={this.openConfirm}
                  >
                    Удалить
                  </Button>
                )}
                <Button
                  disabled={!this.state.saveEnable}
                  variant="contained"
                  color="primary"
                  onClick={this.submit}
                  className={classes.button}
                >
                  {this.state.isSaving ? 'Сохранение...' : (this.state.id ? 'Сохранить' : 'Создать')}
                </Button>
              </div>
              <TextField
                required
                name="name"
                value={this.state.name}
                label="Название"
                className={classes.field}
                onChange={this.handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
              <Select
                className={classes.field}
                name="complexId"
                value={this.state.complexId}
                multi={false}
                options={centersOptions}
                onChange={selected => this.handleSelect(selected ? selected.value : null, 'complexId')}
                clearable={false}
                placeholder="Спортивный центр *"
                noResultsText="Не найдено"
              />
              <Select
                className={classes.field}
                name="sport"
                value={sport}
                options={sportsOptions}
                onChange={selected => this.handleSelect(selected.map(item => item.value), 'sport')}
                clearable={false}
                multi
                placeholder="Вид спорта"
                noResultsText="Не найдено"
              />
              <Select
                className={classes.field}
                name="cover"
                value={this.state.cover}
                multi={false}
                options={coversOptions}
                onChange={selected => this.handleSelect(selected ? selected.value : null, 'cover')}
                clearable
                placeholder="Тип покрытия"
                noResultsText="Не найдено"
              />
              {sport.includes(sportsEnum.snow) && (
                <TextField
                  name="tracksNumber"
                  value={this.state.tracksNumber != null ? String(this.state.tracksNumber) : ''}
                  label="Число трасс"
                  className={classes.field}
                  onChange={this.handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              )}
              {/* Если у нас указаны только лыжи, то трибуны не показываем */}
              {sport && sport.length && sport[0] === sportsEnum.snow ? null : (
                <TextField
                  name="tribune"
                  value={this.state.tribune != null ? String(this.state.tribune) : ''}
                  label="Места на трибунах"
                  className={classes.field}
                  onChange={this.handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              )}
              <FormControl component="fieldset" required className={classes.radioSet}>
                <FormLabel component="legend">Тип площадки</FormLabel>
                {/* Показываем для всех видов спорта, кроме лыж и тренажерного зала */}
                {sport.every(sportType =>
                  ![sportsEnum.snow, sportsEnum.fitness].includes(sportType)) && (
                  <RadioGroup
                    name="type"
                    value={this.state.type ?? 'Indoor'}
                    className={classes.radioGroup}
                    onChange={this.handleChange}
                  >
                    <FormControlLabel value="Indoor" control={<Radio />} label="В помещении" />
                    <FormControlLabel value="Outdoor" control={<Radio />} label="Открытая" />
                  </RadioGroup>
                )}
                {sport.includes(sportsEnum.snow) && (
                  <RadioGroup
                    name="cafe"
                    value={String(this.state.cafe === true)}
                    className={classes.radioGroup}
                    onChange={this.handleChange}
                  >
                    <FormControlLabel value="false" control={<Radio />} label="Нет кафе" />
                    {/* eslint-disable-next-line react/jsx-boolean-value */}
                    <FormControlLabel value="true" control={<Radio />} label="Кафе" />
                  </RadioGroup>
                )}
                {sport.includes(sportsEnum.fitness) && (
                  <RadioGroup
                    name="womensClub"
                    value={String(this.state.womensClub === true)}
                    className={classes.radioGroup}
                    onChange={this.handleChange}
                  >
                    <FormControlLabel value="false" control={<Radio />} label="Общий" />
                    {/* eslint-disable-next-line react/jsx-boolean-value */}
                    <FormControlLabel value="true" control={<Radio />} label="Женский" />
                  </RadioGroup>
                )}
              </FormControl>
              <FormControl component="fieldset">
                <FormLabel component="legend" className={classes.radioSet}>
                  Дополнительно
                </FormLabel>
                <FormGroup row className={classes.checkboxes}>
                  {sport.includes(sportsEnum.fitness) && (<FormControlLabel
                    control={
                      <Checkbox
                        checked={!!this.state.pool}
                        onChange={this.handleChange}
                        name="pool"
                      />
                    }
                    label="Бассейн"
                  />)}
                  {/* Если у нас указан только тренажерный зал, то не показываем */}
                  {sport && sport.length && sport[0] === sportsEnum.fitness ? null : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!this.state.lighting}
                          onChange={this.handleChange}
                          name="lighting"
                        />
                      }
                      label="Освещение"
                    />
                  )}
                </FormGroup>
              </FormControl>
            </Paper>
            <Paper className={classes.paperImages} elevation={2}>
              <Typography type="h5">Загрузка фотографий</Typography>
              {this.state.id === undefined ? (
                <div>Добавление фотографий доступно после сохранения площадки</div>
              ) : (
                <div>
                  <Dropzone onDrop={this.onDrop} className={classes.droparea}>
                    <p>Перетащите сюда изображения или кликните для выбора файла</p>
                  </Dropzone>

                  <ul>
                    {(this.state.images || []).map(f => (
                      <div key={f.id} className={classes.photoContainer}>
                        <div>
                          <img
                            alt="Изображение"
                            className={classes.imgPreview}
                            src={imageSrc(f.id)}
                          />
                        </div>
                        <div className={classes.photoButtons}>
                          <Button 
                            onClick={() => this.setCover(f.id)}
                            className={classes.button}
                            variant="outlined"
                          >
                            Поставить на обложку
                          </Button>
                          <Button 
                            color="secondary" 
                            variant="contained"
                            onClick={() => this.deletePhoto(f.id)}
                            className={classes.button}
                          >
                            Удалить
                          </Button>
                        </div>
                      </div>
                    ))}
                  </ul>
                </div>
              )}
            </Paper>
          </div>
        ) : null}
        {this.state.currentMenu === 1 ? (
          <div>
            <Timetable
              sport={sport}
              sports={sports}
              playgroundId={this.state.id}
              submit={this.submit}
              currentWorkingHoursTypes={currentWorkingHoursTypes}
              workingHoursTypes={workingHoursTypes}
              workingHoursSports={workingHoursSports}
              changeCurrentWorkingHoursType={type => this.changeCurrentWorkingHoursType(type)}
              addWorkingHoursType={() => this.addWorkingHoursType()}
              onWorkingHoursSportsChange={this.handleWorkingHoursSportsChange}
              initialDate={this.getInitialDateFromQuery()}
              initialSectionFilterId={this.getInitialSectionIdFromQuery()}
              sportComplexId={(() => {
                const c = this.state.complexId;
                if (c == null || c === '') return null;
                const n = Number(c);
                return Number.isFinite(n) ? n : null;
              })()}
            />
            {this.renderWorkingHours()}
          </div>
        ) : null}
        {this.state.currentMenu === 2 ? (
          <Paper className={classes.paper} elevation={2}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>id</TableCell>
                  <TableCell>Пользователь</TableCell>
                  <TableCell>Сообщение</TableCell>
                  <TableCell>Оценка</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.reviews.map(review => (
                  <TableRow
                    key={review.id}
                    onClick={() => this.setState({ choosenReview: review })}
                  >
                    <TableCell>{review.id}</TableCell>
                    <TableCell>{review.user.name}</TableCell>
                    <TableCell>
                      {review.message.slice(0, 30)}
                      {review.message.length > 30 ? '...' : null}
                    </TableCell>
                    <TableCell>{review.rate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <Dialog open={Boolean(this.state.choosenReview)}>
                <DialogTitle>Информация об отзыве</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {this.state.choosenReview ? (
                      <div>
                        <Typography type="body1">
                          Сообщение: {this.state.choosenReview.message}
                        </Typography>
                        <Typography type="body1">
                          Оценка: {this.state.choosenReview.rate}
                        </Typography>
                        <Typography type="body1">
                          Пользователь:{' '}
                          {this.state.choosenReview.user.name
                            ? this.state.choosenReview.user.name
                            : 'Логин'}
                        </Typography>
                        <Typography type="body1">
                          Телефон:{' '}
                          {this.state.choosenReview.user.phone
                            ? this.state.choosenReview.user.phone
                            : 'Телефон'}
                        </Typography>
                      </div>
                    ) : (
                      <Typography type="body1">Нет информации</Typography>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {this.props.userRole === 'administrator' && (
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={() => this.deleteComment(this.state.choosenReview)}
                      className={classes.button}
                    >
                      Удалить
                    </Button>
                  )}
                  <Button 
                    onClick={() => this.setState({ choosenReview: null })} 
                    color="primary"
                    variant="outlined"
                    className={classes.button}
                  >
                    Отмена
                  </Button>
                </DialogActions>
              </Dialog>
            </Table>
          </Paper>
        ) : null}
        <ConfirmDialog
          open={openConfirm}
          onClose={this.closeConfirm}
          onConfirm={this.deletePlayground}
          text="Вы действительно хотите удалить площадку?"
        />
      </div>
      </AdminPageShell>
    );
  }
}

const styles = (theme) => ({
  paper: {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'stretch',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    marginBottom: theme.spacing(2),
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  paperImages: {
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'stretch',
    marginTop: 0,
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  pageBody: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    width: '100%',
    padding: 0,
    boxSizing: 'border-box',
    minHeight: 0,
  },
  backButton: {
    alignSelf: 'flex-start',
    marginLeft: theme.spacing(-1),
    paddingTop: 4,
    paddingBottom: 4,
    textTransform: 'none',
    fontWeight: 500,
    color: '#000000',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  flex: {
    flex: 1,
    display: 'flex',
  },
  field: {
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    marginTop: theme.spacing(2),
    overflow: 'visible',
    boxSizing: 'border-box',
    '& .MuiInputLabel-formControl': {
      position: 'relative',
      transform: 'none !important',
      transformOrigin: 'top left',
      top: 0,
      left: 0,
      fontSize: '0.875rem',
      marginBottom: 4,
      whiteSpace: 'nowrap',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'none !important',
    },
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
      },
    },
    '& .Select': {
      width: '100%',
    },
    '& .Select-control': {
      width: '100%',
    },
  },
  fieldShort: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 10,
    width: '100%',
    boxSizing: 'border-box',
  },
  radioSet: {
    marginTop: 15,
    marginLeft: 15,
  },
  radioGroup: {
    flexDirection: 'row',
  },
  flexRow: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  flexCol: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  help: {
    margin: 10,
  },
  interval: {
    width: 40,
  },
  price: {
    marginLeft: 0,
    width: '100%',
  },
  workingHoursTable: {
    marginTop: theme.spacing(2),
    '& thead th': {
      backgroundColor: '#f8f9fa',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
      padding: theme.spacing(1.5),
    },
    '& tbody tr': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    '& tbody td': {
      borderBottom: '1px solid #e9ecef',
      padding: theme.spacing(1),
      verticalAlign: 'middle',
    },
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#495057',
    borderBottom: '2px solid #dee2e6',
    padding: theme.spacing(1.5),
  },
  timeCell: {
    width: '180px',
    minWidth: '180px',
    fontWeight: 500,
    padding: theme.spacing(1.5),
    whiteSpace: 'nowrap',
  },
  priceCell: {
    padding: theme.spacing(1),
  },
  saveButton: {
    width: 'fit-content',
    height: 'fit-content',
  },
  saveButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: 30,
  },
  removeButton: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginRight: theme.spacing(2.5),
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
    '&:disabled': {
      opacity: 0.6,
    },
  },
  droparea: {
    width: '100%',
    height: 200,
    marginTop: 10,
    borderWidth: 2,
    borderColor: 'rgb(102,102,102)',
    borderStyle: 'dashed',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  photoContainer: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'column',
  },
  imgPreview: {
    height: 'auto',
    width: 'auto',
    maxWidth: 300,
    maxHeight: 300,
  },
  checkboxes: {
    marginLeft: 15,
    marginRight: 15,
  },
  workingHoursHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    marginRight: 20,
  },
  workingHoursSportsField: {
    width: '100%',
    marginRight: 20,
    marginBottom: 10,
  },
});

const Styled = withStyles(styles)(Playground);
export default connect(
  state => ({
    centers: state.centers,
    playgrounds: state.playgrounds,
    sports: state.sports,
    covers: state.covers,
    userRole: state.auth.role,
  }),
  {
    updatePlayground,
    createPlayground,
    uploadPhoto,
    deletePhoto,
    setCover,
    deletePlayground,
    fetchCenters,
  }
)(Styled);
